import React from 'react'
import Footer from '../Footer';
import Header from '../Header';
import Servicedata from '../Api/service';

function Loanservice() {

  

  return (
    <>
     <Header/>

      <section className="hero-section">
        <div className="container">
          <div className="row text-white align-items-center">
            <h1>Loan</h1>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-light rounded-pill"
              >
                SERVICES
              </button>
            </div>
            <h1 style={{ textAlign: 'center' }}>
              <span>Loans</span> <span className="link-primary">Service</span>
            </h1>
          </div>
        </div>
      </section>
      <section id="about" className="about section light-background">

        <div className="container">
          <div className="row">
            <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay={200}>
              <div className="about-content ps-0 ps-lg-3">
                {/* <h3>"Innovation is not just our Strength; it is our Foundation."</h3> */}
                <p className="fst-italic">
                  Whether you're looking to buy a new home, expand your business, or need personal financing, <b>Sai Financial Service</b> helps you secure loans from leading banks and financial institutions. We offer personalized loan solutions with competitive interest rates and flexible repayment terms.
                </p>
                <h3>Loan Types Offered:</h3>
                <ol style={{ listStyle: 'disc' }}>
                  <li><p className="fst-italic"><b>Home Loans:</b> Purchase your dream home with ease through our home loan services.</p></li>
                  <li><p className="fst-italic"><b>Personal Loans:</b> Get quick and hassle-free personal loans for your immediate financial needs.</p></li>
                  <li><p className="fst-italic"><b>Business Loans:</b> Expand your business or manage cash flow with our range of business loan options.</p></li>
                  <li><p className="fst-italic"><b>Vehicle Loans:</b> Own your dream car or bike with customized vehicle loan options.</p></li>
                  <li><p className="fst-italic"><b>Loan Against Property:</b>  Unlock the potential of your property to get funds for your business or personal needs.</p></li>
                  <li><p className="fst-italic"><b>Others Loan:</b> We also provide other loan services like education loans, gold loans, agricultural loans and other loans designed to meet specific financial requirements.</p></li>
                </ol>
                <h3>Why Choose Us?</h3>
                <ol style={{ listStyle: 'disc' }}>
                  <li><p className="fst-italic"><b>Wide Network of Lenders:</b> We have partnerships with all major banks and financial institutions, allowing us to find the right loan offer for you.</p></li>
                  <li><p className="fst-italic"><b>Expert Guidance:</b> Our team of loan experts helps you throughout the loan process, from application to disbursement.</p></li>
                  <li><p className="fst-italic"><b>Customized Solutions:</b> Based on your needs and financial situation, we offer tailored loan solutions with competitive interest rates.</p></li>
                </ol>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay={100}>
              <img src="assets\images\svg\loans.jpg" alt className="h-100 p-2 img-fluid" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">

            <h1 style={{ textAlign: 'center' }}>
              <span>Loans</span> <span className="link-primary">Service</span>
            </h1>
          </div>
        </div>
      </section>
      <Servicedata/>
      <Footer />
    </>
  )
}

export default Loanservice
